import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastProvider } from "@/components/toast";
import { AuthProvider } from "@/contexts/AuthContext";
import CenteredBrandLayout from "@/layouts/CenteredBrandLayout";
import AdminShellLayout from "@/layouts/AdminShellLayout";

const LoginPage = lazy(() => import("@/pages/auth/LoginPage"));
const AuthCallback = lazy(() => import("@/pages/auth/AuthCallback"));
const ResetPasswordPage = lazy(() => import("@/pages/auth/ResetPasswordPage"));

const ComplianceVersionsPage = lazy(
  () => import("@/pages/settings/ComplianceVersionsPage")
);


const PageLoader = () => (
  <div className="min-h-screen flex flex-col items-center justify-center space-y-4 bg-slate-950 text-white">
    <div className="w-10 h-10 border-4 border-brand-accent border-t-transparent rounded-full animate-spin" />

    <p className="text-[10px] font-black uppercase tracking-[0.35em] text-slate-400">
      Loading admin console...
    </p>
  </div>
);

const NotFound = () => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-slate-950 text-white">
    <h1 className="text-4xl font-black text-slate-700">404</h1>

    <p className="mt-2 text-[10px] font-black uppercase tracking-[0.5em] text-slate-500">
      Admin Path Not Found
    </p>
  </div>
);

function AdminRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<CenteredBrandLayout />}>
          <Route
            path="/login"
            element={
              <Suspense fallback={<PageLoader />}>
                <LoginPage />
              </Suspense>
            }
          />

          <Route
            path="/auth/callback"
            element={
              <Suspense fallback={<PageLoader />}>
                <AuthCallback />
              </Suspense>
            }
          />

          <Route
            path="/reset-password"
            element={
              <Suspense fallback={<PageLoader />}>
                <ResetPasswordPage />
              </Suspense>
            }
          />
        </Route>

        <Route path="/admin" element={<AdminShellLayout />}>
          <Route
            path="compliance"
            element={
              <Suspense fallback={<PageLoader />}>
                <ComplianceVersionsPage />
              </Suspense>
            }
          />


          <Route path="*" element={<NotFound />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default function AdminApp() {
  return (
    <AuthProvider>
      <ToastProvider>
        <AdminRoutes />
      </ToastProvider>
    </AuthProvider>
  );
}